import * as React from 'react'

import { BaseDiv, ContactDiv, ContentDiv, LeftSide, PrincipalDiv } from './styles';

interface IFooterProps {
  lp?: boolean;
}


const OndeEstamos: React.FC<IFooterProps> = ({ lp }) => {
  return (
    <PrincipalDiv>
      <BaseDiv>
        <ContentDiv>
          <LeftSide>
              ONDE <br className="desktop-break" />ESTAMOS
          </LeftSide>
          <ContactDiv>
            <p>comercial@bhbusmidia.com.br<br/><br/></p>
            <p>Comercial: (31) 98302-4595 - (31) 3248 7095<br/><br/></p>
            <p>R. Aquiles Lobo, 504 - 9° andar Floresta, Belo Horizonte - MG<br/><br/></p>
              <p></p>
          </ContactDiv>
        </ContentDiv>
      </BaseDiv>
    </PrincipalDiv>
  );
};

export { OndeEstamos };